import React, { useState, useEffect, Children } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { getAssessmentReportPage } from '../../redux/actions/assessment'
import AssessmentReportDynamicWidgets from '../../widgets/assessment/AssessmentReportDynamicWidgets'

export default function ReprotCompetenciesPartner() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentReportPage(5, 1, 5)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      {schema && <AssessmentReportDynamicWidgets schema={schema} type={5} />}
    </SidebarProposal>
  )
}

const mocSchema = {
  header: 'รายงานข้อมูลพื้นฐานและสมรรถนะของภาคี',
  searchForm: [
    {
      name: 'budgetYear',
      label: 'ปีงบประมาณ',
      type: '1',
    },
    {
      name: 'email',
      label: 'email',
      type: '1',
    },
    {
      name: 'startDate',
      label: 'วันที่เริ่มต้น',
      type: '3',
    },
    {
      name: 'endDate',
      label: 'วันที่สิ้นสุด',
      type: '3',
    },
  ],
  resultData: {
    columnConfig: [
      {
        key: 'budgetYear',
        label: 'ปีงบประมาณ',
        width: 120,
        align: 'center',
        seq: 1,
      },
      {
        key: 'processDate',
        label: 'Timestamp',
        align: 'center',
        width: 120,
        seq: 1,
      },
      {
        key: 'email',
        label: 'อีเมล',
        width: 300,
        seq: 1,
      },
      {
        key: 'score',
        label: 'Score',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'dynamicData',
        label: 'dynamicData',
        width: 0,
        seq: 1,
        children: [
          {
            key: '1',
            label: '1.ท่านมีบทบาทใดในการดำเนินงานร่วมกับสำนัก 6',
            width: 200,
            seq: 1,
          },
          {
            key: '2',
            label: '2.ดำเนินงานภายใต้โครงการประเภทใด (เลือกได้มากกว่า 1 ข้อ)',
            width: 200,
            seq: 1,
          },
          {
            key: '2',
            label: '2.ดำเนินงานภายใต้โครงการประเภทใด (เลือกได้มากกว่า 1 ข้อ)',
            width: 200,
            seq: 1,
          },
          {
            key: '2',
            label: '3.พื้นที่รับผิดชอบ  (เลือกได้มากกว่า 1 ข้อ)',
            width: 200,
            seq: 1,
          },

          {
            key: '2',
            label: '4.รหัสโครงการ (ปีปัจจุบัน)* เช่น 68-xxxxx',
            width: 200,
            seq: 1,
          },
        ],
      },
    ],
    total: 1,
    values: [
      {
        rowNum: 1,
        budgetYear: '1',
        processDate: '2',
        email: '3',
        score: '2025',
        dynamicData: ['1', '2', '3', '4'],
      },
    ],
  },
}
